import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mirror"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M8 8.5V17.5H3L8 8.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M16 8.5V17.5H21L16 8.5Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 3L12 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M8 8.5V17.5H3L8 8.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M16 8.5V17.5H21L16 8.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const Mirror = Vue.extend<IconProps>({
  name: 'MirrorIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'mirror',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Mirror;
